import React from 'react';
import { Scale, Phone } from 'lucide-react';
import { motion } from 'framer-motion';
export function Navbar() {
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className="fixed top-0 left-0 right-0 z-40 glass-panel border-b border-zinc-200/50" data-id="element-45">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-46">
        <div className="flex items-center gap-3 text-zinc-900" data-id="element-47">
          <div className="w-10 h-10 rounded-xl bg-zinc-900 flex items-center justify-center text-white" data-id="element-48">
            <Scale size={20} data-id="element-49" />
          </div>
          <div data-id="element-50">
            <h1 className="font-bold text-lg leading-tight tracking-tight" data-id="element-51">
              Правовий Захист
            </h1>
            <p className="text-xs text-zinc-500 font-medium uppercase tracking-wider" data-id="element-52">
              Адвокатське бюро
            </p>
          </div>
        </div>

        <div className="hidden md:flex items-center gap-8" data-id="element-53">
          <a href="#services" className="text-sm font-semibold text-zinc-500 hover:text-zinc-900 transition-colors" data-id="element-54">
            Послуги
          </a>
          <a href="#contact" className="text-sm font-semibold text-zinc-500 hover:text-zinc-900 transition-colors" data-id="element-55">
            Контакти
          </a>
          <a href="tel:+380688087800" className="flex items-center gap-2 bg-zinc-900 text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-zinc-800 transition-colors" data-id="element-56">
            <Phone size={16} data-id="element-57" />
            <span data-id="element-58">+38 068 808 78 00</span>
          </a>
        </div>
      </div>
    </motion.nav>;
}